var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListingEditImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#BCBCBE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3535 7.91311L13.586 6.14661C13.4928 6.05327 13.3665 6.00057 13.2346 6C13.1027 5.99944 12.976 6.05107 12.882 6.14361L8.548 10.4101C8.48044 10.477 8.43313 10.5616 8.4115 10.6541L7.8995 12.8726L7 14.0001H8.414L8.985 13.4356L10.779 13.0216C10.869 13.0006 10.9515 12.9551 11.0175 12.8906L15.351 8.62311C15.398 8.57679 15.4354 8.52163 15.461 8.46078C15.4866 8.39994 15.4999 8.33464 15.5002 8.26863C15.5004 8.20263 15.4875 8.13723 15.4624 8.07621C15.4372 8.01519 15.4002 7.95976 15.3535 7.91311ZM10.669 11.8296L9.6085 10.7696L13.23 7.20411L14.29 8.26411L10.669 11.8296ZM7 15.0001H15V16.0001H7V15.0001Z",
    fill: "#2E2E2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingEditImage);
export default __webpack_public_path__ + "static/media/listing-edit-image.e4e6f14218e32add1bb2abe2465fa54c.svg";
export { ForwardRef as ReactComponent };